import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';
import { BanksService } from '../bank-management/banks.service';
import { DmtService } from '../services/dmt.service';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.scss']
})
export class ComplaintComponent implements OnInit {
  isloading: boolean;
  isCreateComplaint: boolean = false;
  CreateComplaintForm: FormGroup;
  submitted: boolean;
  imgaeUrl = "https://yourmudrauatreceipt.yourmudra.com/complaint/";
  
  services = [

    { serviceName: 'Aadhaar Pay', value: 'FINGPAY_AADHAR_SERVICE' },
    { serviceName: 'AePS Balance Enquiry (Kotak)', value: 'FINGPAY_AEPS_BALANCEINQUIRY' },
    { serviceName: 'AePS Balance Enquiry (YesBank)', value: 'YAEPS_BALANCEINQUIRY' },
    { serviceName: 'AePS Cash Withdrawl (Kotak)', value: 'FINGPAY_AEPS_CASHWITHDRAWL' },
    { serviceName: 'YB Cash Withdrawl (YesBank)', value: 'YAEPS_CASHWITHDRAWL' },
    { serviceName: 'AePS Mini Statement (Kotak)', value: 'FINGPAY_AEPS_MINISTATEMENT' },
    { serviceName: 'AePS Mini Statement (YesBank)', value: 'YAEPS_MINISTATEMENT' },
    { serviceName: 'CMS', value: 'CMS' },
    // { serviceName: 'YB DMT IMPS', value: 'YDMT_IMPS' },
    // { serviceName: 'YB DMT NEFT', value: 'YDMT_NEFT' },
    { serviceName: 'FINO DMT IMPS', value: 'FDMT_IMPS' },
    { serviceName: 'FINO DMT NEFT', value: 'FDMT_NEFT' },
    { serviceName: 'eKYC', value: 'EKYC' },
    { serviceName: 'Move to Bank IMPS', value: 'CF_IMPS' },
    { serviceName: 'Move to Bank NEFT', value: 'CF_NEFT' },
    { serviceName: 'mATM Balance Enquiry', value: 'MATM_BALANCEINQUIRY' },
    { serviceName: 'mATM Cash Withdrawal', value: 'MATM_CASHWITHDRAWL' },
    { serviceName: 'RazorPay', value: 'RAZORPAY' },
    { serviceName: 'Recharge DTH', value: 'DTH_RECHARGE' },
    { serviceName: 'Recharge Mobile', value: 'MOBILE_RECHARGE' },
    { serviceName: 'Other', value: 'OTHER' },

    // { serviceName: 'YES BANK BBPS(ELECTRICITY)', value: 'BBPS_ELECTRICITY' },
    // { serviceName: 'YES BANK BBPS(WATAR)', value: 'BBPS_WATAR' },
    // { serviceName: 'YES BANK BBPS(GAS)', value: 'BBPS_GAS' },
    // { serviceName: 'YES BANK BBPS(LPG GAS)', value: 'BBPS_LPG_GAS' },
    // { serviceName: 'YES BANK BBPS(LOAN REPAYMENT)', value: 'BBPS_LOAN' },
    // { serviceName: 'YES BANK BBPS(LOAN FASTAG)', value: 'BBPS_FASTAG' },



  ];
  fileSize: any;
  url: any;

  userImagesize: boolean;
  userImage = "";
  userImageName: any;
  errorFile2: any;
  userImagefilerealimage: any = "";
  UserImagefilerealimageflag: any;
  isImage: boolean = true;
  isVideo: boolean;
  currentUserDetails: any;
  ComplaintList: any;
  ComplaintListCount: any;
  /* presentation only: which status tab is showing */
  complaintStatus: string = 'INPROCESS';


  constructor(private service: AuthService, private router: Router, private toastr: ToastrService, private modalService: NgbModal,
    config: NgbModalConfig, private ngxService: NgxUiLoaderService,
    private formBuilder: FormBuilder) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.CreateComplaintForm = this.formBuilder.group({
      sevice: ["", Validators.required],
      details: ["", Validators.required]
    });

  }
  get f() { return this.CreateComplaintForm.controls; }

  ngOnInit(): void {
    this.getComplaintApi('INPROCESS');
  }
  getComplaintApi(status) {
    // INPROCESS, RESOLVED
    this.ngxService.start();

    this.service.getComplaint(status).subscribe((res: any) => {
      this.ngxService.stop();

      if(res.statusCode == 1){
        this.ComplaintList=res.data
        this.ComplaintListCount=this.ComplaintList[0].chats.length-1;
      }else {
      }
    },err=>{
    this.ngxService.stop();

    })

  }
  openChat(complaints, complaintId) {
    this.service.setChat(complaints)
    this.router.navigate(['complaint-chat', complaintId]);
  }
  createComplaint() {

    this.isCreateComplaint = true;
  }

  selectedUpload(value) {
    console.log(value);
    this.UserImagefilerealimageflag = false;
    this.userImage = "";
    this.userImageName = "";
    this.userImagefilerealimage = "";
    if (value == 'image') {
      this.isImage = true;
      this.isVideo = false;

    } else {
      this.isVideo = true;
      this.isImage = false;

    }
  }
  complaintType(value) {
    this.ComplaintList = [];
    this.getComplaintApi(value);

  }
  createComplaintSubmit() {
    this.ngxService.start();
    this.currentUserDetails = JSON.parse(localStorage.getItem('currentUser'));
    var createdByName = localStorage.getItem('retailorName');
    this.service.createComplaint(this.CreateComplaintForm.value, this.userImage, createdByName).subscribe((res: any) => {
      if (res.statusCode == 1) {
        this.isCreateComplaint = false;
        this.toastr.success("Complaint Successfully Register");
        this.CreateComplaintForm.reset();
        this.CreateComplaintForm.get('sevice').clearValidators();
        this.CreateComplaintForm.get('sevice').updateValueAndValidity();
        this.CreateComplaintForm.get('details').clearValidators();
        this.CreateComplaintForm.get('details').updateValueAndValidity();
        this.getComplaintApi('INPROCESS');

      } else {
        this.toastr.error(res.error.message);

      }
      this.ngxService.stop();
      console.log(res);

    }, err => {
      this.ngxService.stop();
      this.toastr.error(err.error.message);

    })
  }
  personalPhoto(event) {
    if (event.target.files[0].size > 32000000) {
      this.userImagesize = true;
    } else {
      this.userImagesize = false;
      if (
        event.target.files[0].type === "image/jpeg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type == "video/mp4" ||
        event.target.files[0].type == "video/x-m4v" ||
        event.target.files[0].type == "video/x-m4v"
      ) {
        this.errorFile2 = "";
        this.userImage = event.target.files[0];
        this.userImageName = event.target.files[0].name;
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {

          this.userImagefilerealimage = reader.result;
        };
        this.UserImagefilerealimageflag = true;
      } else {
        this.userImage = "";
        this.errorFile2 = "file not supported";
      }
    }
  }

  closeLog(type) {
    switch (type) {
      case "photo":
        this.UserImagefilerealimageflag = false;
        this.userImage = "";
        this.userImageName = "";
        this.userImagefilerealimage = "";
        break;
    }
  }

  mapOfServices(serviceName) {
    switch (serviceName) {
      case "FINGPAY_AADHAR_SERVICE":
        return "Aadhaar Pay";
      case "FINGPAY_AEPS_BALANCEINQUIRY":
        return "Aadhaar Pay";
      case "YAEPS_BALANCEINQUIRY":
        return "Aadhaar Pay";
      case "FINGPAY_AEPS_CASHWITHDRAWL":
        return "Aadhaar Pay";
      case "YAEPS_CASHWITHDRAWL":
        return "Aadhaar Pay";
      case "FINGPAY_AEPS_MINISTATEMENT":
        return "Aadhaar Pay";
      case "YAEPS_MINISTATEMENT":
        return "Aadhaar Pay";
      case "CMS":
        return "CMS";
      case "FDMT_IMPS":
        return "Aadhaar Pay";
      case "FDMT_NEFT":
        return "Aadhaar Pay";
      case "EKYC":
        return "Aadhaar Pay";
      case "CF_IMPS":
        return "Aadhaar Pay";
      case "CF_NEFT":
        return "Aadhaar Pay";
      case "MATM_BALANCEINQUIRY":
        return "Aadhaar Pay";
      case "MATM_CASHWITHDRAWL":
        return "Aadhaar Pay";
      case "RAZORPAY":
        return "Aadhaar Pay";
      case "DTH_RECHARGE":
        return "Aadhaar Pay";
      case "MOBILE_RECHARGE":
        return "Aadhaar Pay";
      case "OTHER":
        return "Aadhaar Pay";

    }
    // "Aadhaar Pay" to "FINGPAY_AADHAR_SERVICE",
    // "AePS Balance Enquiry Kotak" to "FINGPAY_AEPS_BALANCEINQUIRY",
    // "AePS Balance Enquiry YesBank" to "YAEPS_BALANCEINQUIRY",
    // "AePS Cash Withdrawl Kotak" to "FINGPAY_AEPS_CASHWITHDRAWL",
    // "AePS Cash Withdrawl YesBank" to "YAEPS_CASHWITHDRAWL",
    // "AePS Mini Statement Kotak" to "FINGPAY_AEPS_MINISTATEMENT",
    // "AePS Mini Statement YesBank" to "YAEPS_MINISTATEMENT",
    // "CMS" to "CMS",
    // "DMT IMPS FINO" to "FDMT_IMPS",
    // "DMT NEFT FINO" to "FDMT_NEFT",
    // "eKYC" to "EKYC",
    // "Move Bank IMPS" to "CF_IMPS",
    // "Move Bank NEFT" to "CF_NEFT",
    // "mTAM Balance Enquiry" to "MATM_BALANCEINQUIRY",
    // "mTAM Cash Withdrawl" to "MATM_CASHWITHDRAWL",
    // "RazorPay" to "RAZORPAY",
    // "Recharge DTH" to "DTH_RECHARGE",
    // "Recharge Mobile" to "MOBILE_RECHARGE",
    // "Other" to "OTHER"


  }
}
